import { Block } from '@aws-sdk/client-textract'

export interface BlockPosition extends PositionOnCanvas {
  id: string
  width: number
  height: number
}

export interface PositionOnCanvas {
  x: number
  y: number
}

export class CanvasUtils {
  private ctx: CanvasRenderingContext2D | null

  constructor(
    public canvas: HTMLCanvasElement,
  ) {
    this.canvas.width = this.canvas.offsetWidth
    this.canvas.height = this.canvas.offsetHeight

    this.ctx = canvas.getContext('2d')
  }

  public clearCanvas() {
    this.ctx?.clearRect(0, 0, this.canvas.width, this.canvas.height)
  }

  public getPosition(block: Block): BlockPosition {
    // all Blocks without a BoundingBox are ignored before this point
    const { Width, Height, Left, Top } = block.Geometry!.BoundingBox!
    const x = (Left ?? 0) * this.canvas.width
    const y = (Top ?? 0) * this.canvas.height
    const width = (Width ?? 0) * this.canvas.width
    const height = (Height ?? 0) * this.canvas.height

    return {
      x,
      y,
      width,
      height,
      id: `${x}-${y}-${width}-${height}`,
    }
  }

  public isPointInRect(block: Block, mousePos: PositionOnCanvas) {
    const { x, y, width, height } = this.getPosition(block)

    return mousePos.x >= x && mousePos.x <= x + width && mousePos.y >= y && mousePos.y <= y + height
  }

  public removeRect(pos: BlockPosition) {
    this.ctx?.clearRect(pos.x, pos.y, pos.width, pos.height)
  }

  public addRect(pos: BlockPosition, fillStyle = 'rgba(255, 0, 0, 0.1)') {
    if (!this.ctx) {
      return
    }

    this.ctx.fillStyle = fillStyle
    this.ctx.fillRect(pos.x, pos.y, pos.width, pos.height)
  }

  public copyText(text?: string) {
    if (!text) {
      return
    }

    navigator.clipboard.writeText(text)
  }

  public getMousePosition(e: MouseEvent): PositionOnCanvas {
    const rect = this.canvas.getBoundingClientRect()

    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    }
  }

  public setCursorStyle(style: string) {
    this.canvas.style.cursor = style
  }
}
